import React, { useEffect } from 'react';
import { eproScaleUrl } from '../../config/config'
import styles from './index.module.scss';
import { Toast } from "antd-mobile";
import { ApiCore } from '../../api';
const api = new ApiCore();
const EPROEvaluation = (props: any) => {
    const query = new URLSearchParams(props.location.search)
    let scaleCode = query.get('scaleCode') as string
    let title = query.get('title') as string
    let recordId = query.get('recordId') as string
    let isScan= (query.get('isScan') || '') as string
    let scaleId = query.get('scaleId') as string
    let subjectCode = (query.get('subjectCode')) as string
    let nextScale : any;
    let scalesList = []
    const scales =  sessionStorage.getItem("scalesList") || "[]"
    if(scales){
        scalesList =  JSON.parse(scales)
    }
    if(scalesList.length){
        const scaleIdIndex = scalesList.map((e:any)=>e.id ).indexOf(Number(scaleId))
        if(scaleIdIndex < scalesList.length-1){
            nextScale= scalesList[scaleIdIndex+1]
        }
    }  
    useEffect(() => {
        document.title = title
        
    }, [])

    const goBack = () => {
        if(isScan){
            props.history.push('/epro/patient/home')
        }else{
            // props.history.go(-2)
            props.history.push('/epro/patient/home')
        }
    }
     const handleNextScale = async ()=>{
        // 控制跳转，实时获取editModel 
        const subjectDetail = await api.getSubjectdDetail({ id: subjectCode })
          
        if(nextScale){
            try {
                const { data, code } = await api.getScaleRecord({ scaleId: nextScale.id })
                if (Number(code) === 0) {
                 recordId = data?.scalaServerRecordId || ''
                }

                if(subjectDetail?.data?.editModel === 1 && nextScale.reportState === 1){
                    props.history.push(`/epro/patient/reportSurvey?recordId=${recordId||'default'}&scaleCode=${nextScale.code||''}`);
                }else{
                    props.history.push(`/epro/patient/evaluation?arrival=${nextScale.arrival}&recordId=${recordId||'default'}&scaleId=${nextScale.id||''}&scaleCode=${nextScale.code||''}&scaleName=${nextScale.name||''}&subjectCode=${subjectCode||''}&backUrl=${props.history.location.pathname}/`);
                }
            } catch (error) {
            
            }
           

        }else{
            Toast.fail("已经是该访视最后一个量表啦！");
        }         

    }
    
    return (
        <div className={styles.evaluationContainer}>
            <div className={styles.iframeContainer}>
                <iframe src={`${eproScaleUrl}scale/report/${recordId}/${scaleCode}`} style={{height: '100%', width: '100%', border: 'none'}}></iframe>
            </div>
            <div className={styles.btnsContainer}>
                <button onClick={goBack}>返回</button>
                {
                    nextScale && <button onClick={handleNextScale} >进入下一个量表</button>
                }
                
            </div>
          
        </div>
    )
}

export default EPROEvaluation